export default {
  Popconfirm: {
    positiveText: 'Confirm',
    negativeText: 'Cancel',
  },
};
